export default __webpack_public_path__ + "static/media/gallery_01.edbbd5a5.jpg";